"use client";

import { ProductSize } from "@/app/product/[product]/hooks/useSizes";
import { useDPC } from "@/lib/depict/useDPC";
import type { GA4Purchase } from "@depict-ai/dpc";
import { Suspense, useEffect, useRef } from "react";

export const ProductSizeId = ({
  depictProductId,
}: {
  depictProductId: string;
}) => {
  const { DPC } = useDPC();

  useEffect(() => {
    DPC?.setProductId(depictProductId);
  }, [DPC, depictProductId]);
  return null;
};

const UnsuspendedSize = ({
  selectedSize,
}: {
  selectedSize?: ProductSize;
}): React.ReactNode => {
  const sizeId = selectedSize?.itemId?.split("-").pop();

  if (sizeId) {
    return <ProductSizeId depictProductId={sizeId} />;
  }

  return null;
};

export const Size: typeof UnsuspendedSize = (props) => {
  return (
    <Suspense fallback={null}>
      <UnsuspendedSize {...props} />
    </Suspense>
  );
};

export const Purchase = ({
  summary,
}: {
  summary: GA4Purchase | null | undefined;
}) => {
  const { DPC } = useDPC();
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (!summary || hasFiredRef.current) return;

    DPC?.sendPurchaseEvent(summary);
    hasFiredRef.current = true;
  }, [DPC, summary]);

  return null;
};
